
<template>
  <vs-popup
    class="popup overflow-hidden"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      v-if="images.length"
      class="flex flex-col items-center"
    >
      <img
        :src="images[currentIndex].file.downloadUrl"
        alt="Preview"
      >
      <div class="flex gap-4 mt-4">
        <vs-button
          @click="prevImage"
          :disabled="images.length <= 1"
        >
          Prev
        </vs-button>
        <vs-button
          @click="nextImage"
          :disabled="images.length <= 1"
        >
          Next
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  methods: {
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prevImage() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
